export default "__VITE_PUBLIC_ASSET__a9e94e57__"